<template>
  <v-col cols="12" sm="4">
    <h4>{{ moduleTitle }}</h4>
    <div class="form-group" v-for="(link,k) in links" :key="k" style="margin: 0">
      <v-text-field
          outlined
              dense
          v-show="link.module_title === moduleTitle"
          v-model="link.title"
          clearable
          label="Title"
          color="primary"
          maxlength="100"
          :counter="100"
          @keyup="update">
      </v-text-field>
      <v-text-field
          v-show="link.module_title === moduleTitle"
          clearable
          outlined
              dense
          label="URL"
          color="primary"
          maxlength="300"
          :counter="300"
          @keyup="update"
          v-model="link.url">
        <template v-slot:append>
          <v-btn
              @click="remove(k)"
              v-show="k || ( !k && links.length > 1)"
              small
              dark
              color="red"
              class="mr-1">
            <v-icon small dark>fas fa-minus-circle</v-icon>
          </v-btn>
          <v-btn
              @click="add(k)"
              v-show="k == links.length-1"
              small
              color="success"
              class="ma-0">
            <v-icon small dark>fas fa-plus-circle</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </div>
  </v-col>
</template>

<script>
import {bus} from "@/main";

export default {
  name: 'module-links',
  props: ['moduleOf', 'moduleFor', 'moduleTitle', 'moduleLinksOld'],
  data() {
    return {
      uploadedReadyLinks: [],
      links: [
        {url: '', title: '', module_title: this.moduleTitle, model: this.moduleOf},
      ],
      syncingFromProps: false,
    }
  },
  watch: {
    links: {
      handler(v) {
        if (this.syncingFromProps || !this.moduleFor) return;
        // Only push groups that have at least one real URL (or keep explicit edits with blank rows
        // after the user interacted — blank-only initial placeholders must not wipe server data).
        const hasUrl = Array.isArray(v) && v.some(l => l && String(l.url || '').trim() !== '');
        if (!hasUrl) {
          if (Object.prototype.hasOwnProperty.call(this.$store.state.uploads.uploadedStateLinks, this.moduleFor)) {
            // User cleared this module after it was in the store — keep module_title for scoped clear.
            this.$set(this.$store.state.uploads.uploadedStateLinks, this.moduleFor, [this.emptyRow()]);
          }
          return;
        }
        this.$set(this.$store.state.uploads.uploadedStateLinks, this.moduleFor, v);
      },
      deep: true
    },
    moduleLinksOld: {
      handler() {
        this.hydrateFromProps();
      },
      deep: true
    }
  },
  mounted() {
    this.hydrateFromProps();
    bus.$on("moduleLinksDeletedByModal", this.resetLinksFromModal);
  },
  beforeDestroy() {
    bus.$off("moduleLinksDeletedByModal", this.resetLinksFromModal);
  },
  methods: {
    emptyRow() {
      return {url: '', title: '', module_title: this.moduleTitle, model: this.moduleOf};
    },
    normalizeOldLinks(raw) {
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;
      return [];
    },
    hydrateFromProps() {
      this.syncingFromProps = true;
      const oldLinks = this.normalizeOldLinks(this.moduleLinksOld);
      this.links = oldLinks.length > 0 ? oldLinks.map(l => ({...l})) : [this.emptyRow()];
      this.$nextTick(() => {
        this.syncingFromProps = false;
        if (this.moduleFor && oldLinks.some(l => l && String(l.url || '').trim() !== '')) {
          this.$set(this.$store.state.uploads.uploadedStateLinks, this.moduleFor, this.links);
        }
      });
    },
    resetLinksFromModal() {
      this.syncingFromProps = true;
      this.links = [this.emptyRow()];
      this.$store.state.uploads.uploadedStateLinks = {};
      this.$nextTick(() => {
        this.syncingFromProps = false;
      });
    },
    add() {
      this.links.push(this.emptyRow());
    },
    update() {
    },
    remove(index) {
      this.links.splice(index, 1);
      if (this.links.length === 0) {
        this.links = [this.emptyRow()];
      }
    },
  }
}
</script>
